import { HyperLink } from '../Form'
import { connect } from 'react-redux'
import _ from 'lodash'
/**
 * 往賣場連結 Component
 */

const ListingLink = props => {
  const {
    swCode,
    buyGdSaleUrl,
    targetListingId,
    className,
    children,
    onClick
  } = props

  const swCodeParameter = swCode
    ? `&sw=${swCode}`
    : ''

  const targetListingURL = `${buyGdSaleUrl}?gdid=${targetListingId}${swCodeParameter}`

  return (
    <HyperLink
      data-role='listing-link'
      target='_blank'
      href={targetListingURL}
      className={className}
      onClick={onClick}
    >
      {children}
    </HyperLink>
  )
}

export default ListingLink

const mapStateToProps = state => {
  const buyGdSaleUrl = _.get(state, 'supplier.sharedLink.buyGdSale')
  return { buyGdSaleUrl }
}

export const ConnectedListingLink = connect(mapStateToProps)(ListingLink)
